import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { individualpayments } from 'models/individualpayments'; // Importing individualpayments model

/**
 * PaymentHistoryView class extends JetView to create a payment history component.
 */
export default class PaymentHistoryView extends JetView {
    /**
     * Configures the view layout and data table structure.
     * @returns {Object} Configuration object for the data table.
     */
    config() {
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Defines the view as a datatable
            select: true, // Enables row selection
            tooltip: true, // Enables tooltips for table cells
            columns: [
                // Defines the columns of the datatable
                {
                    id: 'date', // Column identifier
                    header: 'Fecha', // Column header
                    sort: 'date', // Enables sorting by date
                    format: dateFormat, // Applies date formatting
                    width: 155, // Sets column width
                    tooltip: '', // Tooltip content (empty)
                },
                {
                    id: 'type', // Column identifier
                    header: 'Tipo', // Column header
                    sort: 'string', // Enables sorting by string
                    adjust: 'header', // Adjusts column width to header
                    tooltip: (obj) => (obj.type ? 'Bought' : 'Sold'), // Tooltip based on type
                    template: (obj) => {
                        // Custom template for displaying icons
                        let type = obj.type ? 'left bought' : 'right sold'; // Determines icon direction
                        return `<span class="webix_icon mdi mdi-arrow-${type}"></span>`; // Returns icon HTML
                    },
                },
                {
                    id: 'item', // Column identifier
                    header: 'Item', // Column header
                    sort: 'string', // Enables sorting by string
                    fillspace: 8, // Allows column to fill available space
                    tooltip: '#item#', // Tooltip displays item name
                },
                {
                    id: 'number', // Column identifier
                    header: 'Quantity', // Column header
                    sort: 'int', // Enables sorting by integer
                    width: 67, // Sets column width
                    tooltip: '', // Tooltip content (empty)
                },
                {
                    id: 'sum', // Column identifier
                    header: 'Cost', // Column header
                    sort: 'int', // Enables sorting by integer
                    format: webix.i18n.priceFormat, // Applies price formatting
                    exportType: 'number', // Specifies export type for this column
                    adjust: 'data', // Adjusts column width to data
                    tooltip: '', // Tooltip content (empty)
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up data synchronization and event listeners.
     * @param {Object} view - The view instance.
     */
    init(view) {
        const cur_user = this.getParam('user', true); // Retrieves current user parameter
        view.sync(individualpayments, function () {
            // Synchronizes view with individualpayments model
            if (cur_user) this.filter((obj) => obj.id % 6 === cur_user % 6); // Filters data based on user ID
        });
        this.on(this.app, 'person:select', (person) => {
            // Event listener for person selection
            individualpayments.waitData.then(() => {
                // Waits for data to be ready
                view.filter((obj) => {
                    // Filters data based on selected person's ID
                    return obj.id % 6 === person.id % 6;
                });
            });
        });
    }
}

// FILE DOCUMENTED
